<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>Newsletter</template>
            <template v-slot:pageDetail>List</template>
        </o-bread-crumb>

        <FeatureGate featureKey="newsletter_module">
            <div v-if="validation">
                <div class="alert alert-danger mt-1" role="alert">
                    {{ validation }}
                </div>
            </div>

            <div v-if="thisComponentShow" class="card text-center bg-white shadow-none">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <h4 class="header-title">
                                <i class="fas fa-newspaper me-2 text-primary"></i>List of Newsletters
                            </h4>
                        </div>
                        <p class="header-subtitle me-4 mt-1">Manage newsletters for members</p>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="spinner d-flex justify-content-center align-items-center" v-if='page.isLoading'>
                    <div class="spinner-border text-primary" role="status"></div>
                </div>

                <div class="" v-if="page.output">
                    <div class="filter-action-wrapper mb-4 mt-3">
                        <div class="filter-controls">
                            <!-- Search Control -->
                            <div class="search-box-custom">
                                <div class="search-type-tabs">
                                    <button class="tab-btn active">
                                        Title
                                    </button>
                                </div>
                                <div class="search-input-wrapper">
                                    <input 
                                        type="text" 
                                        class="form-control-search" 
                                        v-model="searchBy.criteria" 
                                        placeholder="Search..." 
                                        @keyup.enter="search()" 
                                    />
                                    <button v-if="!isSearchActive" class="btn-search" @click="search()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button v-else class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Status Filter -->
                            <div class="filter-section">
                                <div class="section-label-tabs">
                                    <span class="label-tab">Status</span>
                                </div>
                                <div class="date-range-box">
                                    <div class="status-filter-box">
                                        <select class="form-select form-control-filter" v-model="filterStatus" @change="applyFilters()">
                                            <option value="">All Status</option>
                                            <option value="draft">Draft</option>
                                            <option value="published">Published</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="action-section">
                            <div class="action-buttons-group">
                                <button class="btn btn-refresh" @click.prevent="resetState()" title="Refresh">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                                <router-link :to="{ name: 'NewsletterSubscribers' }" class="btn btn-subscribers">
                                    <i class="fas fa-users me-1"></i> Subscribers
                                </router-link>
                                <router-link v-if="write" :to="{ name: 'NewsletterForm' }" class="btn btn-add">
                                    <i class="fas fa-plus me-1"></i> Add New
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <o-table style="text-align:left;" class="table-hover newsletter-list-table">
                        <thead>
                            <tr>
                                <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                    {{ field }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in newsletters" :key="item.id" @click="goToEdit(item.id)" class="newsletter-row-clickable">
                                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <div class="newsletter-cover me-2" v-if="item.cover_image">
                                            <img :src="item.cover_image" :alt="item.title">
                                        </div>
                                        <span class="newsletter-title" :title="item.title">{{ truncate(item.title, 25) }}</span>
                                    </div>
                                </td>
                                <td>{{ formatTiers(item.tiers) }}</td>
                                <td>{{ item.targets_count || 0 }}</td>
                                <td>{{ item.reads_count || 0 }}</td>
                                <td>
                                    <span class="status-badge" :class="getStatusClass(item.status)">
                                        {{ item.status }}
                                    </span>
                                </td>
                                <td>
                                    <span>{{ item.creator ? item.creator.first_name + ' ' + item.creator.last_name : '-' }}</span>
                                </td>
                                <td>
                                    <span class="date-text">{{ dateTimeFormat(item.created_at) }}</span>
                                </td>
                                <td>
                                    <span class="date-text" v-if="item.published_at">{{ dateTimeFormat(item.published_at) }}</span>
                                    <span class="date-text" v-else>Not Published Yet</span>
                                </td>
                                <td class="ml-3">
                                    <div class="d-flex gap-2" @click.stop>
                                        <div v-if="write && item.status === 'draft' && isNewsletterModuleEnabled">
                                            <button 
                                                class="btn btn-action btn-publish"
                                                @click.prevent="publishNewsletter(item)"
                                                :disabled="page.isPublishing === item.id"
                                            >
                                                <span v-if="page.isPublishing === item.id" class="spinner-border spinner-border-sm me-1"></span>
                                                <i v-else class="fas fa-paper-plane me-1"></i> Publish
                                            </button>
                                        </div>
                                        <div v-if="write && isNewsletterModuleEnabled">
                                            <router-link 
                                                class="btn btn-action btn-edit"
                                                :to="{ name: 'NewsletterEdit', params: { id: item.id } }">
                                                <i class="fas fa-edit me-1"></i> Edit
                                            </router-link>
                                        </div>
                                        <div v-if="write && isNewsletterModuleEnabled">
                                            <a href="#" 
                                                class="btn btn-action btn-delete"
                                                @click.prevent="destroy(item.id, item.title)">
                                                <i class="fas fa-trash-alt me-1"></i> Delete
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="newsletters.length === 0">
                                <td colspan="10" class="text-center">No newsletters found</td>
                            </tr>
                        </tbody>
                    </o-table>
                </div>
            </div>

            <!-- Summary Cards -->
            <div class="total-summary mt-4 mb-3">
                <div class="row g-3">
                    <div class="col-md-4">
                        <div class="summary-card">
                            <div class="summary-content">
                                <div class="summary-icon icon-primary">
                                    <i class="fas fa-newspaper"></i>
                                </div>
                                <div class="summary-details">
                                    <p class="summary-label">Total Newsletters</p>
                                    <h3 class="summary-value">{{ meta.total || 0 }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="summary-card">
                            <div class="summary-content">
                                <div class="summary-icon icon-warning">
                                    <i class="fas fa-file-alt"></i>
                                </div>
                                <div class="summary-details">
                                    <p class="summary-label">Draft</p>
                                    <h3 class="summary-value">{{ totalDraft }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="summary-card">
                            <div class="summary-content">
                                <div class="summary-icon icon-success">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="summary-details">
                                    <p class="summary-label">Published</p>
                                    <h3 class="summary-value">{{ totalPublished }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container mt-5">
                <o-pagination :page="meta.page" :total="meta.last_page || 0" @callback="navPage" />
            </div>
        </div>

        <!-- Publish Modal -->
        <o-modal v-if="showPublishModal" @close="showPublishModal = false" modal-class="show d-block">
            <template v-slot:body>
                <div class="modal-body-content p-3">
                    <div class="text-center mb-4">
                        <div class="icon-circle success-icon mb-3 mx-auto">
                            <i class="fas fa-paper-plane"></i>
                        </div>
                        <h5 class="modal-title-custom mb-2">Publish Newsletter</h5>
                        <p class="modal-subtitle">
                            Are you sure you want to publish <br><strong>"{{ selectedItem?.title }}"</strong>?
                        </p>
                    </div>

                    <p class="text-muted small mb-3">Publishing this newsletter will trigger the following actions:</p>
                    
                    <ul class="action-list mb-4">
                        <li>
                            <i class="fas fa-columns text-primary"></i>
                            <div>
                                <strong>Dashboard Visibility</strong>
                                <span class="text-muted d-block small">Visible to all targeted members on their dashboard.</span>
                            </div>
                        </li>
                        <li>
                            <i class="fas fa-envelope text-warning"></i>
                            <div>
                                <strong>Email Blast</strong>
                                <span class="text-muted d-block small">Send email notification to all targeted members.</span>
                            </div>
                        </li>
                        <li>
                            <i class="fas fa-bell text-info"></i>
                            <div>
                                <strong>Push Notification</strong>
                                <span class="text-muted d-block small">Send push notification to member's devices.</span>
                            </div>
                        </li>
                    </ul>
                    
                    <div class="action-footer w-100">
                        <button class="btn-confirm-action btn-success-action mb-2" @click="confirmPublish">
                            Yes, Publish Now
                        </button>
                        <button class="btn-cancel-link" @click="showPublishModal = false">Cancel</button>
                    </div>
                </div>
            </template>
        </o-modal>

        <!-- Delete Warning Box -->
        <o-warning-box
            v-if="showDeleteModal"
            title="Delete Newsletter"
            :item-name="selectedItem?.title || 'this newsletter'"
            warning-message="This action cannot be undone."
            confirm-text="Yes, Delete"
            cancel-text="Cancel"
            @confirm="confirmDelete"
            @cancel="showDeleteModal = false"
        />
        </FeatureGate>
    </div>
</template>

<script>
import store from '@/store/'
import { OTable, OPagination, OBreadCrumb, OWarningBox, OModal } from '@/components/OmnihControl'
import FeatureGate from '@/components/upsell/FeatureGate.vue'
import { useToast } from '@/composables/useToast'

export default {
    name: 'Newsletter',
    components: {
        OTable,
        OPagination,
        OBreadCrumb,
        OWarningBox,
        OModal,
        FeatureGate
    },
    data() {
        return {
            fields: [
                'No',
                'Title',
                'Target Tiers',
                'Target Members',
                'Reads',
                'Status',
                'Created By',
                'Created At',
                'Published At',
                'Action'
            ],
            page: {
                isLoading: false,
                output: false,
                component: 'newsletter',
                isPublishing: null
            },
            searchBy: {
                criteria: ''
            },
            filterStatus: '',
            validation: '',
            thisComponentShow: true,
            write: false,
            showPublishModal: false,
            showDeleteModal: false,
            selectedItem: null,
            isSearchActive: false
        }
    },
    setup() {
        const { toasts, showToast, removeToast } = useToast()
        return { toasts, showToast, removeToast }
    },
    computed: {
        newsletters() {
            return this.$store.state.Newsletter.newsletters || []
        },
        meta() {
            return this.$store.state.Newsletter.meta || { page: 1, limit: 10, total: 0 }
        },
        totalDraft() {
            return this.meta.total_draft || 0
        },
        totalPublished() {
            return this.meta.total_published || 0
        },
        isNewsletterModuleEnabled() {
            return (this.$store.state.FeatureFlag?.newsletterModule?.flag || 'ACTIVE') === 'ACTIVE'
        }
    },
    mounted() {
        this.initLoad()
    },
    watch: {
        '$store.state.Auth.selfLoaded': {
            handler(newVal) {
                if (newVal) {
                    this.initLoad()
                }
            },
            immediate: true
        }
    },
    methods: {
        initLoad() {
            if (this.$store.state.Auth.selfLoaded) {
                this.checkUserPermissions()
                this.load_state()
            }
        },

        checkUserPermissions() {
            if (store.state.Auth.currUser.level === 'root') {
                this.write = true
                return
            }

            const userModules = store.state.Auth.userInfo.modules
            if (userModules) {
                const matchingModule = userModules.find(module => module.module_name === this.page.component)
                if (matchingModule) {
                    this.write = matchingModule.write
                } else {
                    this.write = false
                    this.thisComponentShow = false
                }
            } else {
                this.write = false
                this.thisComponentShow = false
            }
        },

        async load_state() {
            this.page.isLoading = true
            this.validation = ''

            try {
                const params = {
                    custom: {
                        page: this.meta.page || 1,
                        limit: this.meta.limit || 10
                    }
                }
                
                if (this.searchBy.criteria) {
                    params.custom.search = this.searchBy.criteria
                }
                
                if (this.filterStatus) {
                    params.custom.status = this.filterStatus
                }

                await store.dispatch('Newsletter/read', params)
                this.page.output = true
                window.scrollTo({ top: 0, behavior: 'smooth' })
            } catch (err) {
                this.validation = err.response?.data?.message || 'Failed to load newsletters'
                this.thisComponentShow = false
            } finally {
                this.page.isLoading = false
            }
        },

        resetState() {
            this.searchBy.criteria = ''
            this.filterStatus = ''
            this.isSearchActive = false
            store.commit('Newsletter/setMeta', { ...this.meta, page: 1 })
            this.load_state()
        },

        goToEdit(id) {
            if (this.write) {
                this.$router.push({ name: 'NewsletterEdit', params: { id } })
            }
        },

        search() {
            this.isSearchActive = !!this.searchBy.criteria
            store.commit('Newsletter/setMeta', { ...this.meta, page: 1 })
            this.load_state()
        },

        clearSearch() {
            this.isSearchActive = false
            this.searchBy.criteria = ''
            this.search()
        },

        applyFilters() {
            store.commit('Newsletter/setMeta', { ...this.meta, page: 1 })
            this.load_state()
        },

        navPage(page) {
            store.commit('Newsletter/setMeta', { ...this.meta, page })
            this.load_state()
        },

        publishNewsletter(item) {
            this.selectedItem = item
            this.showPublishModal = true
        },

        async confirmPublish() {
            if (!this.selectedItem) return
            
            this.showPublishModal = false
            const itemId = this.selectedItem.id
            this.page.isPublishing = itemId

            try {
                await store.dispatch('Newsletter/publish', itemId)
                this.showToast({
                    type: 'success',
                    title: 'Published',
                    message: `Newsletter has been published successfully.`
                })
                this.load_state()
            } catch (err) {
                this.showToast({
                    type: 'error',
                    title: 'Publish Failed',
                    message: err.response?.data?.message || 'Failed to publish newsletter'
                })
            } finally {
                this.page.isPublishing = null
                this.selectedItem = null
            }
        },

        destroy(id, title) {
            this.selectedItem = { id, title }
            this.showDeleteModal = true
        },

        async confirmDelete() {
            if (!this.selectedItem) return

            this.showDeleteModal = false
            const itemId = this.selectedItem.id
            this.page.isLoading = true

            try {
                await store.dispatch('Newsletter/delete', itemId)
                this.showToast({
                    type: 'success',
                    title: 'Deleted',
                    message: `Newsletter has been deleted successfully.`
                })
                this.load_state()
            } catch (err) {
                this.showToast({
                    type: 'error',
                    title: 'Delete Failed',
                    message: err.response?.data?.message || 'Failed to delete newsletter'
                })
            } finally {
                this.page.isLoading = false
                this.selectedItem = null
            }
        },

        formatTiers(tiers) {
            if (!tiers || tiers.length === 0) return 'All Members'
            if (tiers.length > 2) return `${tiers.length} Tiers`
            return tiers.map(t => t.name).join(', ')
        },

        dateTimeFormat(dateStr) {
            if (!dateStr) return '-'
            const date = new Date(dateStr)
            return date.toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        truncate(text, length = 25) {
            if (!text) return ''
            if (text.length <= length) return text
            return text.substring(0, length) + '..'
        },

        getStatusClass(status) {
            return {
                'status-draft': status === 'draft',
                'status-published': status === 'published'
            }
        }
    }
}
</script>


<style scoped>
/* Feature Disabled State */
.feature-disabled-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 2rem;
}

.disabled-content {
    text-align: center;
    color: #6b7280;
}

.disabled-content h4 {
    color: #374151;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.disabled-content p {
    margin: 0;
    font-size: 0.95rem;
}

/* Filter and Action Bar Styling (Matched with Transaction Pattern) */
.filter-action-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.filter-section, .action-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.section-label-tabs {
    display: flex;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
}

.label-tab {
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 600;
    color: var(--primary-color, #0d6efd);
    background: white;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.filter-controls {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

/* Custom Search Box */
.search-box-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 0 1 350px;
    min-width: 250px;
}

.search-type-tabs {
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
}

.tab-btn {
    border: none;
    background: transparent;
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
}

.tab-btn.active {
    background: white;
    color: var(--primary-color, #0d6efd);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-weight: 600;
}

.search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 4px;
    transition: all 0.2s;
}

.search-input-wrapper:focus-within {
    border-color: var(--primary-color, #0d6efd);
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

.search-input-wrapper input {
    border: none;
    padding: 8px 12px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
}

.btn-search {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-search:hover {
    background: #e2e8f0;
    color: var(--primary-color, #0d6efd);
}

/* Pseudo Date Range Box for Alignment Consistency */
.date-range-box {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 46px; /* Match height of search box */
}

.status-filter-box {
    display: flex;
    align-items: center;
}

.form-control-filter {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    height: 46px; /* Match search input height */
    min-width: 150px;
    background-color: white;
}

.form-control-filter:focus {
    border-color: var(--primary-color, #0d6efd);
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

/* Action Buttons */
.action-buttons-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-refresh {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 8px;
}

.btn-refresh:hover {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
}

.btn-add {
    background-color: var(--primary-color, #0d6efd);
    color: white;
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-add:hover {
    filter: brightness(0.9);
    color: white;
}

.btn-subscribers {
    background-color: #fff;
    color: var(--primary-color);
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: 1px solid var(--primary-color);
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-subscribers:hover {
    background-color: var(--primary-color);
    color: white;
}

/* Table Styles from Transaction */
.newsletter-list-table {
    white-space: nowrap;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.newsletter-list-table th,
.newsletter-list-table td {
    padding: 12px 16px !important;
    vertical-align: middle;
}

.newsletter-row-clickable {
    cursor: pointer;
    transition: background-color 0.2s;
}

.newsletter-row-clickable:hover {
    background-color: #f8fafc !important;
}

.newsletter-cover {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
}

.newsletter-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.newsletter-title {
    font-weight: 500;
    color: #1a1a2e;
}

.status-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: capitalize;
}

.status-draft {
    background: #fff3cd;
    color: #856404;
}

.status-published {
    background: #d4edda;
    color: #155724;
}

.date-text {
    font-size: 13px;
    color: #4a5568;
    white-space: nowrap;
}

/* Action Buttons in Table */
.btn-action {
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    border: none;
}

.btn-publish {
    background: #28a745;
    color: white;
}

.btn-publish:hover {
    background: #218838;
}

.btn-publish:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.btn-edit {
    background-color: #f3f4f6;
    color: #374151;
}

.btn-edit:hover {
    background-color: #e5e7eb;
    color: #111827;
}

.btn-delete {
    background-color: #fff1f2;
    color: #9f1239;
}

.btn-delete:hover {
    background-color: #ffe4e6;
    color: #be123c;
}

/* Summary Cards */
.total-summary {
    padding: 0 10px;
}

.summary-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    height: 100%;
}

.summary-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.summary-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.summary-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
    flex-shrink: 0;
}

.icon-primary {
    background-color: var(--primary-color, #F93E3E);
}

.icon-warning {
    background-color: #f59e0b; /* Warning/Yellow */
}

.icon-success {
    background-color: #28a745; /* Success/Published */
}

.summary-details {
    flex: 1;
    min-width: 0;
}

.summary-label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin: 0 0 2px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.summary-value {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    line-height: 1.2;
    color: #212529;
}

/* Responsive */
@media (max-width: 991px) {
    .filter-controls {
        flex: 100%;
        flex-direction: column;
        align-items: stretch;
    }
    
    .search-box-custom {
        min-width: 100%;
    }

    .date-range-box {
        width: 100%;
    }
    
    .status-filter-box, .form-control-filter {
        width: 100%;
    }

    .action-buttons-group {
        flex: 100%;
        margin-top: 12px;
    }
    
    .btn-add {
        flex: 1;
        justify-content: center;
    }
}

/* Spinner Overlay */
.spinner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 200;
}
</style>

<style scoped>
/* Modal Pattern Styles */
.modal-header-visual {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    margin-bottom: 0.5rem;
}

.icon-circle {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin: 0 auto 1.5rem;
}

.icon-circle.success-icon {
    background: #ecfdf5;
    color: #10b981;
}

.modal-title-custom {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    margin-bottom: 0.5rem;
}

.modal-subtitle {
    color: #6b7280;
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0;
}

.action-footer {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
}

.btn-confirm-action {
    width: 100%;
    padding: 0.75rem;
    border-radius: 8px;
    border: none;
    font-weight: 500;
    color: white;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-success-action {
    background: #10b981;
}
.btn-success-action:hover {
    background: #059669;
}

.btn-cancel-link {
    width: 100%;
    background: transparent;
    border: none;
    color: #6b7280;
    font-weight: 500;
    cursor: pointer;
    padding: 0.5rem;
}

.btn-cancel-link:hover {
    color: #374151;
    text-decoration: underline;
}

.header-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    display: flex;
    align-items: center;
}

.header-subtitle {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
}

/* Action List Styles */
.action-list {
    list-style: none;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background-color: #f9fafb;
    margin-top: 1rem;
}

.action-list li {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    font-size: 0.875rem;
    color: #4b5563;
    text-align: left;
}

.action-list li:last-child {
    border-bottom: none;
}

.action-list li i {
    width: 20px;
    text-align: center;
    margin-top: 3px;
    flex-shrink: 0;
    font-size: 1rem;
}

.action-list li strong {
    color: #1f2937;
    display: block;
    margin-bottom: 0.125rem;
}

.action-list li .text-muted {
    color: #6b7280 !important;
}

/* Icon Colors */
.text-primary {
    color: var(--primary-color, #3b82f6) !important;
}

.text-success {
    color: #10b981;
}

.text-danger {
    color: #dc2626;
}

.text-warning { 
    color: #f59e0b !important;
}   

.text-info { 
    color: #06b6d4 !important;
}
</style>
